module.exports = __webpack_public_path__ + "static/img/spB_3.55b30fa.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/spB_3.png
// module id = 1283
// module chunks = 1